import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import '../styles/CreateCompany.css';
import { jwtDecode } from 'jwt-decode';
const apiUrl = process.env.REACT_APP_API_URL;

function CreateCompany() {
  const [nome, setNome] = useState('');
  const [logo, setLogo] = useState('');
  const [imagem, setImagem] = useState('');
  const [setorAtuacao, setSetorAtuacao] = useState('');
  const [telefoneSuporte, setTelefoneSuporte] = useState('');
  const [emailSuporte, setEmailSuporte] = useState('');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const navigate = useNavigate();
  const { token } = useAuth();

  const handleCreateCompany = async (e) => {
    e.preventDefault();
    setError('');
    setSuccess('');

    try {
      const decodedToken = jwtDecode(token);
      const id_adm = decodedToken.id;

      const response = await fetch(`${apiUrl}admins/adicionar-empresa`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify({
          id_adm,
          nome,
          logo,
          imagem,
          setor_atuacao: setorAtuacao,
          telefone_suporte: telefoneSuporte,
          email_suporte: emailSuporte
        })
      });

      const data = await response.json();
      console.log('Dados recebidos:', data);

      if (response.status === 201) {
        setSuccess('Empresa criada com sucesso!');
        setTimeout(() => {
          navigate('/hall');
        }, 3000);
      } else {
        setError(data.message || 'Erro ao adicionar empresa.');
      }
    } catch (error) {
      console.error('Erro ao adicionar empresa:', error);
      setError('Erro ao adicionar empresa.');
    }
  };

  return (
    <div className="create-company-container">
      <h2>Criação de Empresa</h2>
      <form onSubmit={handleCreateCompany}>
        <div>
          <label>Nome da Empresa:</label>
          <input type="text" value={nome} onChange={(e) => setNome(e.target.value)} required />
        </div>
        <div>
          <label>Logo (Imagem):</label>
          <input type="text" value={logo} onChange={(e) => setLogo(e.target.value)} required />
        </div>
        <div>
          <label>Outra Imagem (Opcional):</label>
          <input type="text" value={imagem} onChange={(e) => setImagem(e.target.value)} />
        </div>
        <div>
          <label>Setor:</label>
          <input type="text" value={setorAtuacao} onChange={(e) => setSetorAtuacao(e.target.value)} required />
        </div>
        <div>
          <label>Telefone de Suporte:</label>
          <input type="text" value={telefoneSuporte} onChange={(e) => setTelefoneSuporte(e.target.value)} />
        </div>
        <div>
          <label>Email de Suporte:</label>
          <input type="email" value={emailSuporte} onChange={(e) => setEmailSuporte(e.target.value)} />
        </div>
        {error && <p style={{ color: 'red' }}>{error}</p>}
        {success && <p style={{ color: 'green' }}>{success}</p>}
        <button type="submit">Criar Empresa</button>
      </form>
    </div>
  );
}

export default CreateCompany;